<template>
    <section class="page-section section-cards" :style="{ marginLeft: '5%', height: '100%' }">
        <div class="container">
            <div class="cards-wrapper" :style="{ width: '100%', height: '100%' }">
                <div class="card-element" :style="{ width: '100%', height: '100%' }">
                    <div class="card-wrapper" :style="{ width: '100%', height: '100%' }">
                        <div class="card-content" :style="{ height: 'auto' }">
                            <h2 v-safe-html="titleHtml" style="font-size: 22px;"></h2>
                            <div v-safe-html="contentSentance" class="content-text"/>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    props: {
        contentTitle: String,
        contentSentance: String,
        buttonText: String,
        buttonLink: String,
    },
    data() {
        return {
            cards: [],
        };
    },
    computed: {
        titleHtml() {
            // TinyMCE wraps the title in <p>, which then gets .card-content p { font-size: 14px }.
            // Unwrap it so the title renders straight inside the <h2> at the intended size.
            return this.contentTitle ? String(this.contentTitle).replace(/<\/?p[^>]*>/gi, '') : '';
        },
    },
};
</script>

<style>
@import '@/css/cardSection.css';

.cards-wrapper {
    display: flex;
    align-items: stretch;
    width: 100%;
    /* Height grows with the content instead of a fixed 32rem block. */
    height: auto;
}

.card-content h2 {
    font-size: 22px;
    /* Space wrapped title lines so they don't overlap (global h2 line-height is 16px). */
    line-height: 1.35;
}

.content-text,
.content-text p {
    font-size: 20px !important;
    font-weight: normal !important;
    letter-spacing: -0.8px;
    line-height: 1.6;
}


</style>
